export default __webpack_public_path__ + "static/media/BudgetTracker.a42b375d.jpg";